const defaultLocationInformationSchema = {
  // Cidadão
  'citizen.streetName': {
    displayName: 'Nome da rua',
    notAvailable: 'Nome da rua não informado',  
  },
  'citizen.streetNumber': {
    displayName: 'Número da residência',
    notAvailable: 'Número da residência não informado',
  },
  'citizen.neighborhood': {
    displayName: 'Bairro',
    notAvailable: 'Bairro não informado',
  },
  'citizen.complement': {
    displayName: 'Complemento',
    notAvailable: 'Complemento não informado',
  },
  'citizen.referencePoint': {
    displayName: 'Ponto de referência',
    notAvailable: 'Ponto de referência não informado',
  },
  'citizen.postalCode': {
    displayName: 'CEP',
    notAvailable: 'CEP não informado',
    mask: 'cep',
  },
  'citizen.state': {
    displayName: 'Estado',
    notAvailable: 'Estado não informado',
  },


  // Geral
  streetName: {
    displayName: 'Endereço',
    notAvailable: 'Endereço não informado',
  },
  state: {
    displayName: 'Estado',
    notAvailable: 'Estado não informado',
  },
  streetNumber: {
    displayName: 'Número da residência',
    notAvailable: 'Número da residência não informado',

  },
  neighborhood: {
    displayName: 'Bairro',
    notAvailable: 'Bairro não informado',
  },
  complement: {
    displayName: 'Complemento',
    notAvailable: 'Complemento não informado',
  },
  referencePoint: {
    displayName: 'Ponto de referência',
    notAvailable: 'Ponto de referência não informado',  
  },
  postalCode: {
    displayName: 'CEP',
    notAvailable: 'CEP não informado',
    mask: 'cep',
  },

}

export default defaultLocationInformationSchema
